var _rect, _rect2, _g, _rect3, _rect4, _path, _path2, _path3, _rect5, _rect6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeemojis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 26,
    viewBox: "0 0 66 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F6F6F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7244_36688)",
    filter: "url(#filter0_d_7244_36688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5614 8.3495C14.4816 9.24651 14.2638 10.111 13.9081 10.9392H10.9473C11.6697 9.84515 12.0078 8.69993 11.9801 7.42733C11.9717 7.02311 12.2644 6.67491 12.6633 6.60964C12.6721 6.60833 12.6805 6.60702 12.6893 6.60565C13.7331 6.43508 14.6544 7.29553 14.5614 8.3495Z",
    fill: "url(#paint0_linear_7244_36688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7673 10.7289L9.28516 10.7285V18.0801H12.6696H17.1095H17.4785C18.4392 18.0801 19.2592 17.3856 19.4173 16.438L19.9837 12.1651C20.1091 11.4133 19.5294 10.7289 18.7673 10.7289Z",
    fill: "url(#paint1_linear_7244_36688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1095 18.0802H17.4786C18.155 18.0802 18.7612 17.7357 19.1162 17.2012L11.0553 10.7286L9.28516 10.7285V18.0801H12.6697L17.1095 18.0802Z",
    fill: "url(#paint2_linear_7244_36688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6915 18.5299H9.8134C9.60149 18.5299 9.42969 18.3581 9.42969 18.1462V10.663C9.42969 10.4511 9.60149 10.2793 9.8134 10.2793H10.6915C10.9034 10.2793 11.0752 10.4511 11.0752 10.663V18.1462C11.0752 18.3582 10.9034 18.5299 10.6915 18.5299Z",
    fill: "url(#paint3_linear_7244_36688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1046 10.2793H9.8134C9.60149 10.2793 9.42969 10.4511 9.42969 10.663V18.1463C9.42969 18.3582 9.60149 18.53 9.8134 18.53H10.6915C10.9034 18.53 11.0752 18.3582 11.0752 18.1463V11.2498L10.1046 10.2793Z",
    fill: "url(#paint4_linear_7244_36688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70202 19.0514H6.40015C6.17916 19.0514 6 18.8723 6 18.6513V10.158C6 9.93697 6.17916 9.75781 6.40015 9.75781H9.70202C9.92304 9.75781 10.1022 9.93697 10.1022 10.158V18.6513C10.1022 18.8723 9.92301 19.0514 9.70202 19.0514Z",
    fill: "url(#paint5_linear_7244_36688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1014 12.2204L8.7938 10.9128C8.60932 10.7119 8.34457 10.5859 8.05033 10.5859C7.4929 10.5859 7.04102 11.0378 7.04102 11.5953C7.04102 11.8895 7.16702 12.1543 7.36791 12.3387L10.1014 15.0722V12.2204H10.1014Z",
    fill: "url(#paint6_linear_7244_36688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05033 12.6046C8.60776 12.6046 9.05964 12.1527 9.05964 11.5952C9.05964 11.0378 8.60776 10.5859 8.05033 10.5859C7.4929 10.5859 7.04102 11.0378 7.04102 11.5952C7.04102 12.1527 7.4929 12.6046 8.05033 12.6046Z",
    fill: "url(#paint7_linear_7244_36688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05202 12.2915C8.43672 12.2915 8.74858 11.9797 8.74858 11.595C8.74858 11.2103 8.43672 10.8984 8.05202 10.8984C7.66733 10.8984 7.35547 11.2103 7.35547 11.595C7.35547 11.9797 7.66733 12.2915 8.05202 12.2915Z",
    fill: "url(#paint8_linear_7244_36688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78671 11.4758C7.86631 11.4758 7.93084 11.4112 7.93084 11.3316C7.93084 11.252 7.86631 11.1875 7.78671 11.1875C7.70711 11.1875 7.64258 11.252 7.64258 11.3316C7.64258 11.4112 7.70711 11.4758 7.78671 11.4758Z",
    fill: "#FFB92D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.316 11.4758C8.3956 11.4758 8.46013 11.4112 8.46013 11.3316C8.46013 11.252 8.3956 11.1875 8.316 11.1875C8.2364 11.1875 8.17188 11.252 8.17188 11.3316C8.17188 11.4112 8.2364 11.4758 8.316 11.4758Z",
    fill: "#FFB92D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78671 12.0051C7.86631 12.0051 7.93084 11.9405 7.93084 11.8609C7.93084 11.7813 7.86631 11.7168 7.78671 11.7168C7.70711 11.7168 7.64258 11.7813 7.64258 11.8609C7.64258 11.9405 7.70711 12.0051 7.78671 12.0051Z",
    fill: "#FFB92D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.316 12.0051C8.3956 12.0051 8.46013 11.9405 8.46013 11.8609C8.46013 11.7813 8.3956 11.7168 8.316 11.7168C8.2364 11.7168 8.17188 11.7813 8.17188 11.8609C8.17188 11.9405 8.2364 12.0051 8.316 12.0051Z",
    fill: "#FFB92D"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F6F6F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0644 7.99598C35.3017 7.91009 33.8417 9.29455 33.8043 11.0294C33.8042 11.0332 33.8029 11.0332 33.8028 11.0294C33.7654 9.29455 32.3054 7.91011 30.5427 7.99598C28.6068 8.09033 27.322 9.98379 27.6619 11.8919C28.2337 15.1011 32.1833 17.3107 33.4284 17.9338C33.6648 18.0521 33.9423 18.0521 34.1787 17.9338C35.4238 17.3107 39.3734 15.1011 39.9451 11.8919C40.2851 9.98379 39.0002 8.09033 37.0644 7.99598Z",
    fill: "url(#paint9_radial_7244_36688)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6985 12.0744C27.7054 12.1057 27.7125 12.137 27.72 12.1682C27.7241 12.185 27.7283 12.2017 27.7325 12.2184C27.74 12.2479 27.7478 12.2774 27.7558 12.3068C27.7603 12.3232 27.7648 12.3396 27.7694 12.3559C27.7785 12.3878 27.7881 12.4194 27.7978 12.4511C27.8018 12.4642 27.8056 12.4774 27.8098 12.4904C27.8237 12.5344 27.8382 12.5782 27.8533 12.6218C27.8567 12.6315 27.8604 12.6412 27.8638 12.651C27.8759 12.685 27.8882 12.719 27.901 12.7527C27.9071 12.769 27.9135 12.7852 27.9198 12.8014C27.9305 12.8287 27.9413 12.8559 27.9524 12.883C27.9595 12.9005 27.9668 12.9179 27.9741 12.9354C27.9852 12.9616 27.9965 12.9877 28.0079 13.0138C28.0154 13.0308 28.0228 13.0478 28.0305 13.0648C28.0435 13.0935 28.0569 13.122 28.0703 13.1506C28.0768 13.1643 28.083 13.1781 28.0896 13.1917C28.109 13.2319 28.1289 13.2718 28.1491 13.3116C28.1577 13.3283 28.1665 13.3448 28.1752 13.3614C28.188 13.3858 28.2008 13.4102 28.2138 13.4344C28.2242 13.4536 28.2348 13.4727 28.2454 13.4918C28.2572 13.5132 28.2692 13.5346 28.2814 13.556C28.2927 13.5758 28.3041 13.5956 28.3156 13.6153C28.3275 13.6357 28.3396 13.6559 28.3517 13.6761C28.3637 13.6962 28.3756 13.7163 28.3878 13.7362C28.3998 13.7557 28.4121 13.7751 28.4243 13.7945C28.4494 13.8344 28.4749 13.8741 28.5008 13.9135C28.5108 13.9289 28.5208 13.9443 28.531 13.9596C28.5464 13.9827 28.5622 14.0056 28.5779 14.0286C28.5881 14.0435 28.5984 14.0585 28.6087 14.0733C28.625 14.0967 28.6414 14.1199 28.6579 14.143C28.6677 14.1568 28.6776 14.1704 28.6874 14.1841C28.7049 14.2082 28.7225 14.2323 28.7402 14.2562C28.7482 14.267 28.7563 14.2777 28.7644 14.2885C28.8342 14.3816 28.9061 14.4732 28.98 14.5633C28.9803 14.5637 28.9806 14.5641 28.9809 14.5644C29.0046 14.5934 29.0286 14.6221 29.0527 14.6507L29.0671 14.6678C29.091 14.6961 29.1151 14.7241 29.1393 14.752L29.1512 14.7656C29.3154 14.954 29.4874 15.1354 29.6644 15.3096L29.6688 15.314C31.0335 16.6551 32.697 17.5682 33.4282 17.9341C33.6645 18.0524 33.942 18.0524 34.1784 17.9341C34.6932 17.6765 35.6703 17.1475 36.6798 16.3889L32.272 11.981C31.9917 11.6723 31.6033 11.4676 31.1486 11.4454C30.3871 11.4083 29.7297 11.8755 29.4804 12.5418L28.9366 12.0011C28.6126 11.6427 28.1374 11.4236 27.6113 11.4451C27.613 11.4793 27.6153 11.5135 27.6179 11.5478C27.6187 11.5577 27.6196 11.5676 27.6205 11.5775C27.6226 11.602 27.6249 11.6265 27.6276 11.651C27.6288 11.6626 27.6301 11.6742 27.6315 11.6858C27.6343 11.7099 27.6375 11.734 27.6408 11.7581C27.6423 11.7686 27.6436 11.7791 27.6452 11.7897C27.6503 11.8238 27.6557 11.858 27.6618 11.8922C27.67 11.9384 27.6791 11.9845 27.6888 12.0303C27.6918 12.0451 27.6952 12.0597 27.6985 12.0744Z",
    fill: "url(#paint10_linear_7244_36688)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1491 11.4454C30.1894 11.3987 29.3945 12.1525 29.3741 13.097C29.3741 13.0991 29.3733 13.0991 29.3733 13.097C29.3529 12.1524 28.558 11.3987 27.5982 11.4454C26.5442 11.4968 25.8446 12.5277 26.0297 13.5667C26.341 15.314 28.4915 16.5171 29.1694 16.8564C29.2981 16.9208 29.4492 16.9208 29.5779 16.8564C30.2559 16.5171 32.4064 15.314 32.7177 13.5667C32.9028 12.5277 32.2032 11.4968 31.1491 11.4454Z",
    fill: "url(#paint11_linear_7244_36688)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F6F6F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.293 11.7442C57.293 9.30938 55.2853 7.34351 52.835 7.41189C50.5076 7.47684 48.6362 9.3947 48.6251 11.723C48.6194 12.9075 49.089 13.9823 49.8542 14.7678C50.5577 15.4899 50.9585 16.4535 50.9585 17.4616V17.7934H54.9595V17.4616C54.9595 16.4583 55.3516 15.4942 56.054 14.7778C56.8204 13.9961 57.293 12.9254 57.293 11.7442Z",
    fill: "url(#paint12_radial_7244_36688)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9586 15.7981C55.1978 15.7981 57.013 13.983 57.013 11.7438C57.013 9.50465 55.1978 7.68945 52.9586 7.68945C50.7195 7.68945 48.9043 9.50465 48.9043 11.7438C48.9043 13.983 50.7195 15.7981 52.9586 15.7981Z",
    fill: "url(#paint13_linear_7244_36688)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.958 10.8521C54.4104 10.8521 55.5878 10.1678 55.5878 9.32353C55.5878 8.4793 54.4104 7.79492 52.958 7.79492C51.5055 7.79492 50.3281 8.4793 50.3281 9.32353C50.3281 10.1678 51.5055 10.8521 52.958 10.8521Z",
    fill: "url(#paint14_linear_7244_36688)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8977 7.86719C55.19 8.45058 55.3548 9.10896 55.3548 9.80591C55.3548 12.1995 53.4144 14.1399 51.0208 14.1399C50.3238 14.1399 49.6654 13.9752 49.082 13.6828C49.7936 15.103 51.2623 16.0781 52.959 16.0781C55.3526 16.0781 57.293 14.1377 57.293 11.7441C57.293 10.0475 56.3179 8.57877 54.8977 7.86719Z",
    fill: "url(#paint15_linear_7244_36688)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.958 16.7089C54.4104 16.7089 55.5878 15.5315 55.5878 14.079C55.5878 12.6266 54.4104 11.4492 52.958 11.4492C51.5055 11.4492 50.3281 12.6266 50.3281 14.079C50.3281 15.5315 51.5055 16.7089 52.958 16.7089Z",
    fill: "url(#paint16_radial_7244_36688)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5369 19.6427C53.5392 20.1199 52.379 20.1199 51.3812 19.6427C51.122 19.5187 50.957 19.2569 50.957 18.9696V16.8066H54.9611V18.9696C54.9611 19.2569 54.7961 19.5187 54.5369 19.6427Z",
    fill: "url(#paint17_linear_7244_36688)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.957 17.271L51.354 17.668H54.9611V17.2676H50.957V17.271Z",
    fill: "url(#paint18_linear_7244_36688)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.957 18.2592L51.354 18.6562H54.9611V18.2559H50.957V18.2592Z",
    fill: "url(#paint19_linear_7244_36688)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9922 19.1953C50.9989 19.2163 51.0065 19.237 51.0151 19.2573L51.3535 19.5957H54.618C54.7648 19.5013 54.8725 19.3591 54.9248 19.1953H50.9922Z",
    fill: "url(#paint20_linear_7244_36688)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0863 14.0781H54.005C53.6827 14.0781 53.4206 14.3403 53.4206 14.6625V14.8508H52.9584H52.4962V14.6625C52.4962 14.3403 52.2341 14.0781 51.9118 14.0781H51.8305C51.5083 14.0781 51.2461 14.3403 51.2461 14.6625C51.2461 14.9848 51.5083 15.2469 51.8305 15.2469H52.1V16.7588H52.4962V15.2469H52.9584H53.4206V16.7588H53.8167V15.2469H54.0863C54.4085 15.2469 54.6707 14.9848 54.6707 14.6625C54.6707 14.3403 54.4085 14.0781 54.0863 14.0781ZM52.0999 14.8511H51.8303C51.7265 14.8511 51.6421 14.7666 51.6421 14.6628C51.6421 14.559 51.7265 14.4746 51.8303 14.4746H51.9116C52.0154 14.4746 52.0999 14.559 52.0999 14.6628V14.8511ZM53.8169 14.8511H54.0864C54.1903 14.8511 54.2747 14.7666 54.2747 14.6628C54.2747 14.559 54.1902 14.4746 54.0864 14.4746H54.0051C53.9013 14.4746 53.8169 14.559 53.8169 14.6628V14.8511Z",
    fill: "url(#paint21_linear_7244_36688)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0863 14.0781H54.005C53.6827 14.0781 53.4206 14.3403 53.4206 14.6625V14.8508H52.9584H52.4962V14.6625C52.4962 14.3403 52.2341 14.0781 51.9118 14.0781H51.8305C51.5083 14.0781 51.2461 14.3403 51.2461 14.6625C51.2461 14.9848 51.5083 15.2469 51.8305 15.2469H52.1V16.7588H52.4962V15.2469H52.9584H53.4206V16.7588H53.8167V15.2469H54.0863C54.4085 15.2469 54.6707 14.9848 54.6707 14.6625C54.6707 14.3403 54.4085 14.0781 54.0863 14.0781ZM52.0999 14.8511H51.8303C51.7265 14.8511 51.6421 14.7666 51.6421 14.6628C51.6421 14.559 51.7265 14.4746 51.8303 14.4746H51.9116C52.0154 14.4746 52.0999 14.559 52.0999 14.6628V14.8511ZM53.8169 14.8511H54.0864C54.1903 14.8511 54.2747 14.7666 54.2747 14.6628C54.2747 14.559 54.1902 14.4746 54.0864 14.4746H54.0051C53.9013 14.4746 53.8169 14.559 53.8169 14.6628V14.8511Z",
    fill: "url(#paint22_linear_7244_36688)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8515 17.2882H51.066C50.8764 17.2882 50.7227 17.1345 50.7227 16.9449C50.7227 16.7553 50.8764 16.6016 51.066 16.6016H54.8515C55.0411 16.6016 55.1948 16.7553 55.1948 16.9449C55.1948 17.1345 55.0411 17.2882 54.8515 17.2882Z",
    fill: "url(#paint23_linear_7244_36688)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8515 18.2745H51.066C50.8764 18.2745 50.7227 18.1208 50.7227 17.9312C50.7227 17.7416 50.8764 17.5879 51.066 17.5879H54.8515C55.0411 17.5879 55.1948 17.7416 55.1948 17.9312C55.1948 18.1208 55.0411 18.2745 54.8515 18.2745Z",
    fill: "url(#paint24_linear_7244_36688)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8515 19.2628H51.066C50.8764 19.2628 50.7227 19.1091 50.7227 18.9195C50.7227 18.7299 50.8764 18.5762 51.066 18.5762H54.8515C55.0411 18.5762 55.1948 18.7299 55.1948 18.9195C55.1948 19.1091 55.0411 19.2628 54.8515 19.2628Z",
    fill: "url(#paint25_linear_7244_36688)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2634 19.7593C53.8992 19.6357 53.4483 19.5625 52.9598 19.5625C52.4714 19.5625 52.0204 19.6357 51.6562 19.7593C52.4956 20.0796 53.4241 20.0796 54.2634 19.7593Z",
    fill: "url(#paint26_linear_7244_36688)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0206 12.0657H47.4459C47.2935 12.0657 47.1699 11.9421 47.1699 11.7897C47.1699 11.6372 47.2935 11.5137 47.4459 11.5137H48.0206C48.173 11.5137 48.2966 11.6373 48.2966 11.7897C48.2966 11.9421 48.173 12.0657 48.0206 12.0657Z",
    fill: "url(#paint27_linear_7244_36688)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4717 12.0657H57.8971C57.7447 12.0657 57.6211 11.9421 57.6211 11.7897C57.6211 11.6372 57.7447 11.5137 57.8971 11.5137H58.4717C58.6242 11.5137 58.7477 11.6373 58.7477 11.7897C58.7478 11.9421 58.6242 12.0657 58.4717 12.0657Z",
    fill: "url(#paint28_linear_7244_36688)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2356 6.85065V6.27599C53.2356 6.12358 53.112 6 52.9596 6C52.8072 6 52.6836 6.12358 52.6836 6.27599V6.85065C52.6836 7.00309 52.8072 7.12664 52.9596 7.12664C53.112 7.12667 53.2356 7.00309 53.2356 6.85065Z",
    fill: "url(#paint29_linear_7244_36688)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2723 8.49275L48.866 8.08639C48.7582 7.97862 48.7582 7.80386 48.866 7.69606C48.9738 7.58829 49.1485 7.58829 49.2563 7.69606L49.6627 8.10242C49.7704 8.21019 49.7704 8.38495 49.6627 8.49275C49.5549 8.60055 49.3801 8.60055 49.2723 8.49275Z",
    fill: "url(#paint30_linear_7244_36688)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6469 8.49275L57.0533 8.08639C57.1611 7.97862 57.1611 7.80386 57.0533 7.69606C56.9455 7.58829 56.7708 7.58829 56.663 7.69606L56.2566 8.10242C56.1488 8.21019 56.1488 8.38495 56.2566 8.49275C56.3644 8.60055 56.5392 8.60055 56.6469 8.49275Z",
    fill: "url(#paint31_linear_7244_36688)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7244_36688",
    x: 4,
    y: 6,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.403922 0 0 0 0 0.403922 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7244_36688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7244_36688",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7244_36688",
    x1: 11.3667,
    y1: 9.31637,
    x2: 12.8382,
    y2: 11.6403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7244_36688",
    x1: 10.7302,
    y1: 16.2517,
    x2: 15.801,
    y2: 21.2793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7244_36688",
    x1: 17.286,
    y1: 11.7471,
    x2: 10.1788,
    y2: 11.7471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7244_36688",
    x1: 8.88358,
    y1: 19.5447,
    x2: 12.5061,
    y2: 19.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7244_36688",
    x1: 10.303,
    y1: 7.32075,
    x2: 7.40354,
    y2: 7.26494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C3C3",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7244_36688",
    x1: 5.7036,
    y1: 17.102,
    x2: 11.956,
    y2: 20.4006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7244_36688",
    x1: 10.3621,
    y1: 10.8694,
    x2: 6.95518,
    y2: 9.28393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A2F3",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7244_36688",
    x1: 7.32052,
    y1: 10.9619,
    x2: 7.32052,
    y2: 12.4214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7244_36688",
    x1: 8.55556,
    y1: 12.0324,
    x2: 8.55556,
    y2: 11.0253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_7244_36688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6214 10.7431) scale(6.8141 5.51536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#FE4773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6292,
    stopColor: "#FC406D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7605,
    stopColor: "#F73464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    stopColor: "#F12257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9606,
    stopColor: "#E80C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7244_36688",
    x1: 36.6622,
    y1: 15.7337,
    x2: 34.6164,
    y2: 11.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7244_36688",
    x1: 25.6035,
    y1: 12.8515,
    x2: 27.9041,
    y2: 17.0217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#FFCA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#FFAA87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_7244_36688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5112 10.1105) scale(6.85767 8.21464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCE3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7244_36688",
    x1: 55.6407,
    y1: 10.0296,
    x2: 51.2445,
    y2: 5.63336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7244_36688",
    x1: 56.1161,
    y1: 10.3086,
    x2: 55.8466,
    y2: 6.92901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7244_36688",
    x1: 58.6494,
    y1: 16.3838,
    x2: 64.6067,
    y2: 5.30402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_7244_36688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.958 14.0791) scale(2.62983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3263,
    stopColor: "#FDEA28",
    stopOpacity: 0.404
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7865,
    stopColor: "#FEE03A",
    stopOpacity: 0.128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA45",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7244_36688",
    x1: 50.957,
    y1: 20.0007,
    x2: 54.9611,
    y2: 20.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7244_36688",
    x1: 55.3329,
    y1: 17.642,
    x2: 55.333,
    y2: 17.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7244_36688",
    x1: 55.3331,
    y1: 18.6303,
    x2: 55.3332,
    y2: 18.1549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7244_36688",
    x1: 55.283,
    y1: 19.5698,
    x2: 55.2831,
    y2: 19.0951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7244_36688",
    x1: 53.8475,
    y1: 15.0509,
    x2: 53.8475,
    y2: 13.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7244_36688",
    x1: 51.901,
    y1: 15.3326,
    x2: 51.901,
    y2: 16.9881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7244_36688",
    x1: 50.9932,
    y1: 16.7029,
    x2: 50.9938,
    y2: 17.3034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7244_36688",
    x1: 50.9932,
    y1: 17.6893,
    x2: 50.9938,
    y2: 18.2897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7244_36688",
    x1: 50.9932,
    y1: 18.6776,
    x2: 50.9938,
    y2: 19.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7244_36688",
    x1: 50.6566,
    y1: 19.6332,
    x2: 50.6596,
    y2: 20.3995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7244_36688",
    x1: 47.1537,
    y1: 11.7254,
    x2: 47.1537,
    y2: 12.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7244_36688",
    x1: 57.6048,
    y1: 11.7254,
    x2: 57.6048,
    y2: 12.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7244_36688",
    x1: 52.8953,
    y1: 7.14289,
    x2: 53.4632,
    y2: 7.14289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7244_36688",
    x1: 49.1093,
    y1: 7.84744,
    x2: 48.7078,
    y2: 8.24894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7244_36688",
    x1: 56.4085,
    y1: 8.24895,
    x2: 56.81,
    y2: 8.65046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7244_36688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeemojis);
export default __webpack_public_path__ + "static/media/likeemojis.25864ba9f5b2af7687152791b72bf9cd.svg";
export { ForwardRef as ReactComponent };